export default "__VITE_ASSET__0c683443__"